import { useSite } from "@/hooks/use-site";
import { resolveLicense, type LicenseId } from "@/lib/license";
import { localizeUrl } from "@/lib/site";

// Human-readable license + republishing line shown at the foot of every post.
// The machine-readable counterparts live in the JSON-LD, the <head> rel="license"
// link, and the feeds.
export function BlogLicenseNotice({ license: licenseId }: { license: LicenseId }) {
  const { messages, site, href } = useSite();
  const license = resolveLicense(licenseId);
  const republishing = localizeUrl("/republishing", site.locale, href);
  // CC BY 4.0 is a stable identifier shown as-is; the "All rights reserved" wording
  // is localized.
  const label = license.republishable ? license.label : messages.blogLicenseAllRightsReserved;

  return (
    <footer className="mt-12 border-t border-border pt-6 text-sm text-muted-foreground">
      <p>
        {messages.blogLicenseLabel}:{" "}
        {license.url ? (
          <a
            className="font-medium text-primary hover:underline"
            href={license.url}
            rel="license noopener noreferrer"
            target="_blank"
          >
            {label}
          </a>
        ) : (
          <span className="font-medium text-foreground">{label}</span>
        )}
        {" — "}
        {license.republishable ? messages.blogLicenseReusableNote : messages.blogLicenseReservedNote}{" "}
        <a className="font-medium text-primary hover:underline" href={republishing}>
          {messages.blogLicenseGuidelines}
        </a>
        .
      </p>
    </footer>
  );
}
